import { render, staticRenderFns } from "./orderVideoSend.vue?vue&type=template&id=4b3177f0&scoped=true&"
import script from "./orderVideoSend.vue?vue&type=script&lang=js&"
export * from "./orderVideoSend.vue?vue&type=script&lang=js&"
import style0 from "./orderVideoSend.vue?vue&type=style&index=0&id=4b3177f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3177f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3177f0')) {
      api.createRecord('4b3177f0', component.options)
    } else {
      api.reload('4b3177f0', component.options)
    }
    module.hot.accept("./orderVideoSend.vue?vue&type=template&id=4b3177f0&scoped=true&", function () {
      api.rerender('4b3177f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderVideoSend.vue"
export default component.exports